module.exports = __webpack_public_path__ + "img/238.22b6cd67.jpg";